import { defineComponent, ref, watch, onMounted, onUnmounted, computed, openBlock, createBlock, Teleport, createElementVNode, normalizeClass, unref, normalizeStyle, withModifiers, renderSlot, createCommentVNode, createElementBlock } from "vue";
import { freeze, unfreeze } from "@motillo/ui-scroll-freeze";
import useNormalizedVh from "@motillo/ui-normalize-vh";
var DrawerLayer_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = /* @__PURE__ */ createElementVNode("div", {
  style: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
  },
  class: "drawer__mask"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("div", { class: "drawer__close-btn" }, " \xD7 ", -1);
let stackOrder = 900;
let keyIndex = 0;
const _sfc_main = /* @__PURE__ */ defineComponent({
  name: "DrawerLayer",
  props: {
    modelValue: { type: Boolean },
    closeOnMaskClick: { type: Boolean, default: true },
    showCloseIcon: { type: Boolean, default: true },
    containerClass: null,
    modalClass: null
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    keyIndex += 1;
    const modalKey = `drawer-${keyIndex}`;
    const zIndex = ref(900);
    const isMounted = ref(false);
    useNormalizedVh();
    watch(() => props.modelValue, (val) => {
      if (val) {
        stackOrder += 1;
        zIndex.value = stackOrder;
        freeze(modalKey);
      } else {
        stackOrder -= 1;
        unfreeze(modalKey);
      }
    });
    onMounted(() => {
      if (props.modelValue) {
        freeze(modalKey);
      }
      isMounted.value = true;
    });
    onUnmounted(() => {
      if (props.modelValue) {
        unfreeze(modalKey);
      }
    });
    const computedClass = computed(() => {
      let classVar = props.modalClass ? props.modalClass : "";
      if (props.modelValue) {
        classVar += " drawer--shown";
      }
      return classVar;
    });
    function close() {
      emit("update:modelValue", false);
    }
    function onMaskClick() {
      if (props.closeOnMaskClick) {
        close();
      }
    }
    return (_ctx, _cache) => {
      return isMounted.value ? (openBlock(), createBlock(Teleport, {
        key: 0,
        to: "#drawer-target"
      }, [
        createElementVNode("div", {
          class: normalizeClass(["drawer", unref(computedClass)]),
          style: normalizeStyle({
            position: "fixed",
            zIndex: zIndex.value,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: __props.modelValue ? "all" : "none"
          }),
          onClick: onMaskClick
        }, [
          _hoisted_1,
          createElementVNode("div", {
            class: normalizeClass(["drawer__container", __props.containerClass]),
            style: normalizeStyle({
              position: "absolute",
              top: 0,
              right: 0,
              height: "calc(var(--vh, 1vh) * 100)",
              width: "100vw",
              overflowY: "auto",
              overflowX: "hidden",
              "-webkit-overflow-scrolling": "touch",
              margin: "0px auto",
              transition: "transform .15s ease",
              transform: __props.modelValue ? "translateX(0%)" : "translateX(100%)"
            }),
            onClick: _cache[1] || (_cache[1] = withModifiers(() => {
            }, ["stop"]))
          }, [
            __props.modelValue ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true),
            __props.showCloseIcon ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: "drawer__close",
              onClick: _cache[0] || (_cache[0] = ($event) => close())
            }, [
              renderSlot(_ctx.$slots, "close", {}, () => [
                _hoisted_2
              ])
            ])) : createCommentVNode("", true)
          ], 6)
        ], 6)
      ])) : createCommentVNode("", true);
    };
  }
});
export { _sfc_main as default };
